import {Resource} from 'app/constants/resource';
import {cond} from 'lodash';
export const AIResource = {
    [Resource.SALE_ORDERS]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                },
                saleOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'saleOrderNo()'
                }
            }
        },
        createOrUpdateEntity: {
            searchOptions: {
                product: {
                    required: true,
                    repeatable: true,
                    function: 'product(,qty:)'
                },
                productWithInfo: {
                    required: true,
                    repeatable: true,
                    function: 'productWithInfo(,qty:,price:,vat:,notes:)'
                },
                route: {
                    required: false,
                    repeatable: false,
                    function: 'route()'
                },
                customer: {
                    required: true,
                    repeatable: false,
                    function: 'customer()'
                },
                deliveryPoint: {
                    required: false,
                    repeatable: false,
                    function: 'deliveryPoint()'
                },
                orderDate: {
                    required: false,
                    repeatable: false,
                    function: 'orderDate' + currentDate()
                },
                purchaseOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'purchaseOrderNo()'
                },
                recentProduct: {
                    required: false,
                    repeatable: true,
                    function: 'recentProduct(,qty:)'
                }
            },
            synonyms: ['addEntity', 'createOrUpdateEntity', 'generateEntity']
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                orderNumber: {
                    required: false,
                    repeatable: false,
                    function: 'orderNumber()'
                },
                deliveryPointName: {
                    required: false,
                    repeatable: false,
                    function: 'deliveryPointName()'
                },
                customerName: {
                    required: false,
                    repeatable: false,
                    function: 'customerName()'
                },
                requestDate: {
                    required: false,
                    repeatable: false,
                    function: 'requestDate' + currentDate()
                },
                scheduledDate: {
                    required: false,
                    repeatable: false,
                    function: 'scheduledDate' + currentDate()
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                orderNumber: {
                    required: false,
                    repeatable: false,
                    function: 'orderNumber()'
                },
                deliveryPointName: {
                    required: false,
                    repeatable: false,
                    function: 'deliveryPointName()'
                },
                customerName: {
                    required: false,
                    repeatable: false,
                    function: 'customerName()'
                },
                requestDate: {
                    required: false,
                    repeatable: false,
                    function: 'requestDate' + currentDate()
                },
                scheduledDate: {
                    required: false,
                    repeatable: false,
                    function: 'scheduledDate' + currentDate()
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.INCOMING_INVENTORIES]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                },
                documentRef: {
                    required: false,
                    repeatable: false,
                    function: 'documentRef()'
                }
            }
        },
        createOrUpdateEntity: {
            searchOptions: {
                product: {
                    required: true,
                    repeatable: true,
                    function: 'product(,qty:)'
                },
                productWithInfo: {
                    required: true,
                    repeatable: true,
                    function: 'productWithInfo(,qty:,price:,vat:,notes:)'
                },
                supplier: {
                    required: true,
                    repeatable: false,
                    function: 'supplier()'
                },
                warehouse: {
                    required: true,
                    repeatable: false,
                    function: 'warehouse()'
                }
            },
            synonyms: ['addEntity', 'createOrUpdateEntity', 'generateEntity']
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                orderPurchaseNumber: {
                    required: false,
                    repeatable: false,
                    function: 'orderPurchaseNumber()'
                },
                incomingDate: {
                    required: false,
                    repeatable: false,
                    function: 'incomingDate' + currentDate()
                },
                destinationWarehouseName: {
                    required: false,
                    repeatable: false,
                    function: 'destinationWarehouseName()'
                },
                supplierName: {
                    required: false,
                    repeatable: false,
                    function: 'supplierName()'
                },
                documentRef: {
                    required: false,
                    repeatable: false,
                    function: 'documentRef()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                orderPurchaseNumber: {
                    required: false,
                    repeatable: false,
                    function: 'orderPurchaseNumber()'
                },
                incomingDate: {
                    required: false,
                    repeatable: false,
                    function: 'incomingDate' + currentDate()
                },
                destinationWarehouseName: {
                    required: false,
                    repeatable: false,
                    function: 'destinationWarehouseName()'
                },
                supplierName: {
                    required: false,
                    repeatable: false,
                    function: 'supplierName()'
                },
                documentRef: {
                    required: false,
                    repeatable: false,
                    function: 'documentRef()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.LOAD_ORDERS]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                },
                loadOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'loadOrderNo()'
                }
            }
        },
        createOrUpdateEntity: {
            searchOptions: {
                product: {
                    required: true,
                    repeatable: true,
                    function: 'product(,qty:)'
                },
                productWithInfo: {
                    required: true,
                    repeatable: true,
                    function: 'productWithInfo(,qty:,price:,vat:,notes:)'
                },
                route: {
                    required: true,
                    repeatable: false,
                    function: 'route()'
                },
                orderDate: {
                    required: true,
                    repeatable: false,
                    function: 'orderDate' + currentDate()
                }
            },
            synonyms: ['addEntity', 'createOrUpdateEntity', 'generateEntity']
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                loadOrderNumber: {
                    required: false,
                    repeatable: false,
                    function: 'loadOrderNumber()'
                },
                loadOrderDate: {
                    required: false,
                    repeatable: false,
                    function: 'loadOrderDate' + currentDate()
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                vehicleName: {
                    required: false,
                    repeatable: false,
                    function: 'vehicleName()'
                },
                documentRef: {
                    required: false,
                    repeatable: false,
                    function: 'documentRef()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                loadOrderNumber: {
                    required: false,
                    repeatable: false,
                    function: 'loadOrderNumber()'
                },
                loadOrderDate: {
                    required: false,
                    repeatable: false,
                    function: 'loadOrderDate' + currentDate()
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                vehicleName: {
                    required: false,
                    repeatable: false,
                    function: 'vehicleName()'
                },
                documentRef: {
                    required: false,
                    repeatable: false,
                    function: 'documentRef()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.PACK_ORDERS]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                },
                saleOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'saleOrderNo()'
                }
            }
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                saleOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'saleOrderNo()'
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                deliveryPointName: {
                    required: false,
                    repeatable: false,
                    function: 'deliveryPointName()'
                },
                scheduledDate: {
                    required: false,
                    repeatable: false,
                    function: 'scheduledDate' + currentDate()
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                saleOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'saleOrderNo()'
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                deliveryPointName: {
                    required: false,
                    repeatable: false,
                    function: 'deliveryPointName()'
                },
                scheduledDate: {
                    required: false,
                    repeatable: false,
                    function: 'scheduledDate' + currentDate()
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.PICK_ORDERS]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                },
                saleOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'saleOrderNo()'
                }
            }
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                saleOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'saleOrderNo()'
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                scheduledDate: {
                    required: false,
                    repeatable: false,
                    function: 'scheduledDate' + currentDate()
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                saleOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'saleOrderNo()'
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                scheduledDate: {
                    required: false,
                    repeatable: false,
                    function: 'scheduledDate' + currentDate()
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.PURCHASE_ORDERS]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                },
                purchaseOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'purchaseOrderNo()'
                }
            }
        },
        createOrUpdateEntity: {
            searchOptions: {
                product: {
                    required: true,
                    repeatable: true,
                    function: 'product(,qty:)'
                },
                productWithInfo: {
                    required: true,
                    repeatable: true,
                    function: 'productWithInfo(,qty:,price:,vat:,notes:)'
                },
                supplier: {
                    required: true,
                    repeatable: false,
                    function: 'supplier()'
                },
                warehouse: {
                    required: true,
                    repeatable: false,
                    function: 'warehouse()'
                }
            },
            synonyms: ['addEntity', 'createOrUpdateEntity', 'generateEntity']
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                purchaseOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'purchaseOrderNo()'
                },
                scheduledDate: {
                    required: false,
                    repeatable: false,
                    function: 'scheduledDate' + currentDate()
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                purchaseOrderNo: {
                    required: false,
                    repeatable: false,
                    function: 'purchaseOrderNo()'
                },
                scheduledDate: {
                    required: false,
                    repeatable: false,
                    function: 'scheduledDate' + currentDate()
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.INVOICES]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                },
                invoiceNo: {
                    required: false,
                    repeatable: false,
                    function: 'invoiceNo()'
                }
            }
        },
        // createOrUpdateEntity: {
        //     searchOptions: {
        //         product: {
        //             required: true,
        //             repeatable: true,
        //             function: 'product(,qty:)'
        //         },
        //         route: {
        //             required: true,
        //             repeatable: false,
        //             function: 'route()'
        //         },
        //         customer: {
        //             required: true,
        //             repeatable: false,
        //             function: 'customer()'
        //         },
        //         deliveryPoint: {
        //             required: true,
        //             repeatable: false,
        //             function: 'deliveryPoint()'
        //         }
        //     }
        // },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                invoiceNo: {
                    required: false,
                    repeatable: false,
                    function: 'invoiceNo()'
                },
                customerName: {
                    required: false,
                    repeatable: false,
                    function: 'customerName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                invoiceNo: {
                    required: false,
                    repeatable: false,
                    function: 'invoiceNo()'
                },
                customerName: {
                    required: false,
                    repeatable: false,
                    function: 'customerName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.CREDIT_NOTES]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                },
                creditNoteNo: {
                    required: false,
                    repeatable: false,
                    function: 'creditNoteNo()'
                }
            }
        },
        createOrUpdateEntity: {
            searchOptions: {
                product: {
                    required: true,
                    repeatable: true,
                    function: 'product(,qty:)'
                },
                productWithInfo: {
                    required: true,
                    repeatable: true,
                    function: 'productWithInfo(,qty:,price:,vat:,notes:)'
                },
                customer: {
                    required: true,
                    repeatable: false,
                    function: 'customer()'
                },
                deliveryPoint: {
                    required: true,
                    repeatable: false,
                    function: 'deliveryPoint()'
                }
            },
            synonyms: ['addEntity', 'createOrUpdateEntity', 'generateEntity']
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                creditNoteNo: {
                    required: false,
                    repeatable: false,
                    function: 'creditNoteNo()'
                },
                customerName: {
                    required: false,
                    repeatable: false,
                    function: 'customerName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                creditNoteNo: {
                    required: false,
                    repeatable: false,
                    function: 'creditNoteNo()'
                },
                customerName: {
                    required: false,
                    repeatable: false,
                    function: 'customerName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.WAREHOUSE_TRANSFERS]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                }
            }
        },
        createOrUpdateEntity: {
            searchOptions: {
                product: {
                    required: true,
                    repeatable: true,
                    function: 'product(,qty:)'
                },
                productWithInfo: {
                    required: true,
                    repeatable: true,
                    function: 'productWithInfo(,qty:,price:,vat:,notes:)'
                },
                sourceWarehouse: {
                    required: true,
                    repeatable: false,
                    function: 'sourceWarehouse()'
                },
                destinationWarehouse: {
                    required: true,
                    repeatable: false,
                    function: 'destinationWarehouse()'
                },
                transferDate: {
                    required: true,
                    repeatable: false,
                    function: 'transferDate' + currentDate()
                }
            },
            synonyms: ['addEntity', 'createOrUpdateEntity', 'generateEntity']
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                sourceWarehouseName: {
                    required: true,
                    repeatable: false,
                    function: 'sourceWarehouseName()'
                },
                destinationWarehouseName: {
                    required: true,
                    repeatable: false,
                    function: 'destinationWarehouseName()'
                },
                transferDate: {
                    required: true,
                    repeatable: false,
                    function: 'transferDate' + currentDate()
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                sourceWarehouseName: {
                    required: true,
                    repeatable: false,
                    function: 'sourceWarehouseName()'
                },
                destinationWarehouseName: {
                    required: true,
                    repeatable: false,
                    function: 'destinationWarehouseName()'
                },
                transferDate: {
                    required: true,
                    repeatable: false,
                    function: 'transferDate' + currentDate()
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.STANDING_ORDERS]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                }
            }
        },
        createOrUpdateEntity: {
            searchOptions: {
                product: {
                    required: true,
                    repeatable: true,
                    function: 'product(,qty:)'
                },
                productWithInfo: {
                    required: true,
                    repeatable: true,
                    function: 'productWithInfo(,qty:,price:,vat:,notes:)'
                },
                route: {
                    required: true,
                    repeatable: false,
                    function: 'route()'
                },
                deliveryPoint: {
                    required: true,
                    repeatable: false,
                    function: 'deliveryPoint()'
                },
                orderDate: {
                    required: true,
                    repeatable: false,
                    function: 'orderDate' + currentDate()
                }
            },
            synonyms: ['addEntity', 'createOrUpdateEntity', 'generateEntity']
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                deliveryPointName: {
                    required: false,
                    repeatable: false,
                    function: 'deliveryPointName()'
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                deliveryPointName: {
                    required: false,
                    repeatable: false,
                    function: 'deliveryPointName()'
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    },
    [Resource.STANDING_LOAD_ORDERS]: {
        openEntity: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: false,
                    function: 'id()'
                }
            }
        },
        createOrUpdateEntity: {
            searchOptions: {
                product: {
                    required: true,
                    repeatable: true,
                    function: 'product(,qty:)'
                },
                productWithInfo: {
                    required: true,
                    repeatable: true,
                    function: 'productWithInfo(,qty:,price:,vat:,notes:)'
                },
                route: {
                    required: true,
                    repeatable: false,
                    function: 'route()'
                },
                orderDate: {
                    required: true,
                    repeatable: false,
                    function: 'orderDate' + currentDate()
                }
            },
            synonyms: ['addEntity', 'createOrUpdateEntity', 'generateEntity']
        },
        saveEntity: {},
        saveAndApproveEntity: {},
        selectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        },
        deSelectEntities: {
            searchOptions: {
                id: {
                    required: false,
                    repeatable: true,
                    function: 'id()'
                },
                routeName: {
                    required: false,
                    repeatable: false,
                    function: 'routeName()'
                },
                condition: {
                    required: false,
                    repeatable: true,
                    function: 'condition()'
                }
            }
        }
    }
};

export function currentDate(): string {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const dd = String(today.getDate()).padStart(2, '0');
    return '(' + `${yyyy}-${mm}-${dd}` + ')';
}

export function currentTime(): string {
    const today = new Date();
    const hh = String(today.getHours() + 1).padStart(2, '0'); // Months are zero-based
    const mm = String(today.getMinutes()).padStart(2, '0');
    return '(' + `${hh}-${mm}` + ')';
}

export const querySearchOptions = {
    column: {
        required: false,
        repeatable: true,
        function: 'column()'
    },
    resource: {
        required: false,
        repeatable: false,
        function: 'resource()'
    },
    condition: {
        required: false,
        repeatable: true,
        function: 'condition()'
    }
};
